/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.insurancebusinessmag.com/ca/news/cyber/settlement-reached-in-stockx-data-breach-class-action-411985.aspx#:~:text=TechCrunch%20reported%20that%20a%20data,shoe%20size%2C%20and%20trading%20currency'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open('https://hk.prnasia.com/story/215617-2.shtml');
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open('https://www.canva.com/help/incident-may24/');
        }}
        className="source3"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.insurancebusinessmag.com/ca/news/cyber/settlement-reached-in-stockx-data-breach-class-action-411985.aspx#:~:text=TechCrunch%20reported%20that%20a%20data,shoe%20size%2C%20and%20trading%20currency'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open('https://hk.prnasia.com/story/215617-2.shtml');
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open('https://www.canva.com/help/incident-may24/');
        }}
        className="source3"
      />
    </div>
  </>
);

export default Components004;
